import { render } from "./BackgroundRoom.vue?vue&type=template&id=20acca84&scoped=true"
import script from "./BackgroundRoom.vue?vue&type=script&lang=js"
export * from "./BackgroundRoom.vue?vue&type=script&lang=js"

import "./BackgroundRoom.vue?vue&type=style&index=0&id=20acca84&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-20acca84"

export default script